import './Loader.scss';
export default function Loader() {
  return (
    <div id="overlay">
      <div className="loader">
        <img
          src="https://remitxb2c.s3.ap-south-1.amazonaws.com/1691587401180-loader.gif"
          alt="loader"
          width={'98px'}
          className="my_loader"
        />
      </div>
    </div>
  );
}
